const animatedConfettiUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/animations/animated-confetti.json";
const imageFireworkUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/images/image-firework.svg";
const imageBalloonsUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/images/image-balloons.svg";
const imageBalloonsBouquetUrl = "https://bounce-web.s3.us-east-2.amazonaws.com/images/image-balloons-bouquet.svg";

export {animatedConfettiUrl, imageFireworkUrl, imageBalloonsUrl, imageBalloonsBouquetUrl};
